import React from 'react';
import { getAdFoxBannerContext, IAdFoxBannerContext, IAdFoxParams } from '@cian/adfox';

import { MortgageInPriceBanner } from '../../../components/MortgageInPriceBanner';
import { useApplicationContext } from '../../../../../../shared/serp/containers/ApplicationContext';
import { trackAdFoxMortgage } from '../../../../../../shared/tracking/adFoxMortgage';
import { useOfferContext } from '../../../context';
import { ContentRow } from '../../../components/ContentRow';

interface IMortgageAdFoxBannerProps {
  onLoad(): void;
}

export function MortgageAdFoxBannerContainer({ onLoad }: IMortgageAdFoxBannerProps) {
  const { trackingData, getMortgageInPriceAdFoxParams } = useOfferContext();
  const { logger } = useApplicationContext();
  const mounted = React.useRef(false);
  const [context, setContext] = React.useState<IAdFoxBannerContext | null>(null);

  const loadContext = React.useCallback(
    async (getAdFoxParams: () => Promise<IAdFoxParams>) => {
      try {
        const adFoxParams = await getAdFoxParams();

        const contextResult = await getAdFoxBannerContext(adFoxParams);
        setContext(contextResult);
        trackAdFoxMortgage('show', 'LinkIpoteka', contextResult.bannerId, trackingData.user, trackingData.page);
      } catch (e) {
        logger.warning(e);
      }
      onLoad();
    },
    [onLoad, logger],
  );

  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      event.stopPropagation();

      if (!context) {
        return;
      }

      trackAdFoxMortgage('show', 'LinkIpoteka', context.bannerId, trackingData.user, trackingData.page);
    },
    [trackingData, context],
  );

  React.useEffect(() => {
    if (!mounted.current) {
      mounted.current = true;
      if (getMortgageInPriceAdFoxParams) {
        loadContext(getMortgageInPriceAdFoxParams);
      }
    }
  }, [loadContext, getMortgageInPriceAdFoxParams]);

  if (!context) {
    return null;
  }

  return (
    <ContentRow>
      <MortgageInPriceBanner link={context.reference} text={context.text} onClick={handleClick} />
    </ContentRow>
  );
}
